<template>
  <div class="offer-item" @click.stop="openTransactions(item.public_id)">
    <div class="name" :title="userName">{{ userName }}</div>
    <div class="issued">
      {{ offerIssuedDate }}
    </div>
    <div class="amount">
      {{ item.got_money / 100 }}
    </div>
    <div class="term">
      {{ offerTerm }}
    </div>
    <div class="percent">
      {{ offerPercent }}
    </div>
    <div class="income">
      {{ item.must_return_money / 100 }}
    </div>
    <div class="issued-by">
      {{ offerIssueDate }}
    </div>
    <div class="peni">
      {{ item.total_penalty / 100 }}
    </div>
    <div class="total-amount">
      {{ (item.rest_debt) / 100 }}
    </div>
    <div class="status">
      <div :class="item.status">
        {{ $t(`message.profile.borrower.activeOffers.status.${item.status}`) }}
      </div>
    </div>
    <div class="pay">
      <div class="btn-block">
        <base-button
          :text="$t(`message.profile.borrower.activeOffers.btn`)"
          class="pay-btn"
          @click="openPayModal()"
          v-if="isShowPayBtn"
          :disabled="!profile.default_card_id"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from '../../components/base/BaseButton.vue';
import { mapGetters } from 'vuex';

export default {
  name: "borrowerLoanItem",
  components: {
    BaseButton
  },
  props: {
    item: Object
  },
  data() {
    return {
      isPayBtnLoading: false,
    }
  },
  methods: {
    openPayModal() {
      this.$emit('openPayModal', { totalAmount: this.item.rest_debt, loan_public_id: this.item.public_id })
    },
    openTransactions(id) {
      this.$router.push({name: 'loan', params: { id }});
    }
  },
  computed: {
    ...mapGetters(['profile']),
    userName() {
      const lastName = this.item?.Offer?.MsiIndividualUser?.name_ru?.family_name_ru;
      const name = (this.item?.Offer?.MsiIndividualUser?.name_ru?.given_name_ru).slice(0, 1) + '.';

      return `${lastName} ${name}`;
    },
    offerIssuedDate() {
      return new Date(this.item?.createdAt).toLocaleDateString();
    },
    offerTerm() {
      return this.item?.Offer?.loan_term_days + 'д.';
    },
    offerPercent() {
      return this.item?.Offer?.annual_percent;
    },
    offerIssueDate() {
      // const dayInMs = 86400000; //День в миллисекундах
      // const offerTermInMs = this.item?.Offer?.loan_term_days * dayInMs;
      // const currentDate = Date.now(this.item?.createdAt);
      // const targetDate = offerTermInMs + currentDate;

      return new Date(this.item?.due_date).toLocaleDateString();
    },
    isShowPayBtn() {
      return this.item.status == 'current_debt' || this.item.status === 'overdue';
    }
  }
};
</script>

<style lang="scss" scoped>
.offer-item {
  width: 100%;
  padding: 20px 20px 20px 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eceef0;
  font-weight: 400;
  font-size: calc(8px + 10 * (100vw / 1920));
  line-height: 135%;
  color: #121212;
  cursor: pointer;

  &:hover {
    background-color: #F6F8FF;
  }
}

.name {
  width: 125px;
  margin-right: 2px;
  @include overflow-elipsis;
}

.issued {
  width: 106px;
  margin-right: 2px;
}

.amount {
  width: 65px;
  margin-right: 2px;
}

.term {
  width: 45px;
  margin-right: 2px;
}

.percent {
  width: 87px;
  margin-right: 2px;
}

.income {
  width: 144px;
  margin-right: 2px;
}

.issued-by {
  width: 117px;
  margin-right: 2px;
}

.peni {
  width: 45px;
  margin-right: 2px;
}

.total-amount {
  width: 65px;
  margin-right: 2px;
}

.status {
  width: 117px;
  margin-right: 11px;
  font-size: calc(6px + 8 * (100vw / 1920));

  div {
    width: fit-content;
    white-space: nowrap;
  }
}

.pay {
  width: calc(70px + 50 * (100vw / 1920));
}

.btn-block {
  width: calc(70px + 49 * (100vw / 1920));
  height: 32px;
}

.payment,
.on_due,
.current_debt,
.payment_pending {
  padding: 5.5px 15px;
  box-sizing: border-box;
  color: #CB7723;
  background: #FFF1D5;
  border-radius: 6px;
}

.closed,
.paid,
.repaid {
  padding: 5.5px 15px;
  box-sizing: border-box;
  color: #21A15C;
  background: #D6F9D3;
  border-radius: 6px;
}

.expired,
.overdue {
  padding: 5.5px 15px;
  box-sizing: border-box;
  color: #C93434;
  background: #FFDBDB;
  border-radius: 6px;
}

.pay-btn ::v-deep {
  background-color: white;
  border: 2px solid #41BF7B;
  border-radius: 6px;
  color: #41BF7B;
  padding: 0;
  font-size: calc(8px + 8 * (100vw / 1920));
  font-weight: 600;

  &:hover {
    background-color: #41BF7B;
    color: white;
  }

  &.disabled {
    background-color: rgba(255, 255, 255, 0.5);
    border: 2px solid rgba(64, 191, 123, 0.5);
    color: rgba(64, 191, 123, 0.5);
  }

  &.disabled:hover {
    background-color: rgba(255, 255, 255, 0.5);
    border: 2px solid rgba(64, 191, 123, 0.5);
    color: rgba(64, 191, 123, 0.5);
  }
}
</style>
